import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import Button from 'oxyrion-ui/lib/Button';
import { connect } from '../../Store';
import { AnimatedFormMessageWrapper } from '../../Components/ReusableComponents';
import ToningCard from '../../Components/ToningCard/index';
import ErrorMessage from '../../Components/ErrorMessage';
import FirstStep from './firstStep';
import SecondStep from './secondStep';
import ThirdStep from './thirdStep';
import FourthStep from './fourthStep';
import { __ } from '../../Utils';

import ToningCardFilter from '../../Components/ToningCardFilter/index';
import API2 from '../../API2';

const ErrorWrapper = styled.div``;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(16)};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${rem(8)};
`;

const Space = styled.div`
  height: ${rem(20)};
  width: ${rem(20)};
`;

const InsideWrapper = styled.div`
  display: flex;
  margin-bottom: ${rem(24)};
  width: 100%;
  flex-direction: column;
`;

class Toning extends React.Component {
  state = {
    error: false,
    prices: [],
    variants: [],
    variantBases: [],
    shadeProperties: [],
    selectedColorCardPurpose: undefined,
    selectedColorId: undefined,
    productId: undefined,
    compMargin: 1,
    brandsFilter: [],
  };

  async componentWillMount() {
    const searchParams = new URLSearchParams(this.props.location.search);

    const productId = searchParams.get('productId');
    const colorId = searchParams.get('colorId');
    const colorcardId = searchParams.get('colorcardId');
    const shadeBases = searchParams.get('shadeBases');

    if (productId) {
      this.setState({
        productId,
        colorcardId,
        colorId,
        shadeBases,
      });
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (
      nextProps.inputProduct &&
      nextProps.inputProduct._id &&
      nextProps.reload !== this.props.reload
    ) {
      const shades = [];

      if (nextProps.inputProduct.variants) {
        nextProps.inputProduct.variants.forEach(v => {
          const shadeParam = v.variantParams.find(
            vp => vp.system_name === 'shade',
          );
          if (shadeParam && shadeParam.value) {
            shades.push(shadeParam.value);
          }
        });
      }

      await this.processFirstStep(
        nextProps.inputProduct,
        [],
        shades,
        nextProps.inputProduct.variants,
      );
    }
  }

  componentWillUnmount() {
    this.setState({
      error: false,
      prices: [],
      variants: [],
      shadeProperties: [],
      shade: undefined,
      selectedColorCardPurpose: undefined,
      selectedColorId: undefined,
      selectedColorCardId: undefined,
      selectedToningSystem: undefined,
      productId: undefined,
      pricesLoading: false,
    });
  }

  onConfirm(o) {
    const { onConfirm, clearAfterConfirm } = this.props;
    const {
      selectedToningSystem,
      selectedColorCardId,
      selectedColorCardPurpose,
      color,
      productId,
    } = this.state;

    const data = Object.assign(o, {
      parentId: productId,
      selectedColorCardPurpose,
      color,
      toningSystem: selectedToningSystem,
      colorCardId: selectedColorCardId,
    });

    onConfirm(data);

    if (clearAfterConfirm) {
      this.setState({
        error: false,
        selectedColorCardId: undefined,
        prices: [],
        shadeProperties: [],
        quantity: 1,
        complementarQuantity: 0,
        selectedToningSystem: undefined,
        selectedColorCardPurpose: undefined,
        selectedColorId: undefined,
        productId: undefined,
        shade: undefined,
      });
    }
  }

  updateQueryMultiple(keysToRemove = [], keysWithValuesToAdd = []) {
    const { pathname } = this.props.location;
    const searchParams = new URLSearchParams(this.props.location.search);

    if (keysToRemove && keysToRemove.length > 0) {
      keysToRemove.forEach(key => searchParams.delete(key));
    }

    if (keysWithValuesToAdd && keysWithValuesToAdd.length > 0) {
      keysWithValuesToAdd.forEach(item => {
        searchParams.set(item.key, item.value);
      });
    }

    this.props.history.replace({
      pathname,
      search: searchParams.toString(),
    });
  }

  reset() {
    const { pathname } = this.props.location;

    this.props.history.replace({
      pathname,
      search: '',
    });

    this.setState({
      error: false,
      selectedColorCardId: undefined,
      prices: [],
      shadeProperties: [],
      quantity: 1,
      complementarQuantity: 0,
      selectedToningSystem: undefined,
      selectedColorCardPurpose: undefined,
      selectedColorId: undefined,
      productId: undefined,
      shade: undefined,
    });

    window.location.reload();
  }

  async processFirstStep(product, variantBases, refreshNextSteps) {
    if (product) {
      if (refreshNextSteps) {
        this.setState({
          productId: product._id,
          variantBases,
          quantity: 1,
          selectedVariant: null,
          shade: null,
          complementarQuantity: 0,
          selectedComplementar: null,
          error: false,
          selectedColorId: null,
        });

        this.updateQueryMultiple(
          ['shadeBases', 'colorcardId', 'colorId'],
          [{ key: 'productId', value: product._id }],
        );
      } else {
        this.setState({
          productId: product._id,
          variantBases,
          quantity: 1,
        });

        this.updateQueryMultiple(
          [],
          [{ key: 'productId', value: product._id }],
        );
      }
    } else {
      this.setState({
        error: false,
        selectedToningSystem: undefined,
        prices: [],
        shade: null,
        shadeProperties: [],
        selectedColorId: undefined,
        selectedColorCardPurpose: undefined,
        selectedColorCardId: undefined,
        productId: undefined,
      });

      this.updateQueryMultiple([
        'productId',
        'shadeBases',
        'colorcardId',
        'colorId',
      ]);
    }
  }

  async processSecondStep(colorCard, shade) {
    const { productId } = this.state;
    const colorId = shade.color_code;
    const shadeBases = shade.basecodes;
    let variants = [];

    this.setState({
      pricesLoading: true,
      error: false,
    });
    let colorCardDetail = {};

    try {
      colorCardDetail = await API2.getB2BColorcardAction(colorCard._id);
    } catch (e) {
      this.setState({
        error: __('Vzorkovník sa nepodarilo načítať'),
      });

      return;
    }

    const completeColorCard = Object.assign(colorCardDetail, colorCard);

    try {
      const result = await API2.getB2BCatalogProductVariantsAction(productId);

      if (completeColorCard.purpose === 'tinting') {
        variants = result.variants.filter(
          v =>
            !shadeBases ||
            shadeBases.indexOf(
              v.variantParams.find(vp => vp.system_name === 'base').label,
            ) > -1,
        );
      } else {
        variants = result.variants.filter(v => v.finished_shade === colorId);
      }

      this.updateQueryMultiple(
        [],
        [
          {
            key: 'colorId',
            value: colorId,
          },
          {
            key: 'shadeBases',
            value: shadeBases,
          },
          {
            key: 'colorcardId',
            value: colorCard._id,
          },
        ],
      );
    } catch (e) {
      console.log(e);
      this.setState({
        error: __('Varianty sa nepodarilo načítať'),
      });

      return;
    }

    const { outputCallback, customerId } = this.props;

    try {
      if (completeColorCard.purpose === 'tinting') {
        const result = await API2.getB2BCatalogProductPricesAction(productId, {
          colorCardId: colorCardDetail._id,
          shadeId: colorId,
          toningSystemId: colorCardDetail.system_id,
          applyDiscounts: this.props.applyDiscount,
          applyMargin: this.props.applyMargin,
          customerId:
            customerId && customerId !== null ? customerId : undefined,
        });

        if (outputCallback) {
          outputCallback({
            prices: result.prices || [],
            shadeProperties: result.shade_properties || [],
            colorants: result.coloraunts || [],
            bases: result.bases || [],
            shadeOfBase: result.shade_of_base || '',
            color: colorCardDetail.shades.find(s => s.color_code === colorId),
            selectedColorId: colorId,
            selectedColorCardId: completeColorCard._id,
            selectedToningSystem: completeColorCard.system_id,
          });

          this.setState({
            error: false,
            prices: [],
            variants: [],
            shadeProperties: [],
            shade: undefined,
            selectedColorCardPurpose: undefined,
            selectedColorId: undefined,
            selectedColorCardId: undefined,
            selectedToningSystem: undefined,
            productId: undefined,
            pricesLoading: false,
          });
        } else {
          const editedVariants = variants.map(v =>
            Object.assign(v, {
              complementary_products:
                v.complementary_products &&
                v.complementary_products.map(c =>
                  Object.assign(c, {
                    price: {
                      amount: c.price.amount * (result.marginOnProduct || 1),
                      currency: c.price.currency,
                    },
                    price_vat: {
                      amount:
                        c.price_vat.amount * (result.marginOnProduct || 1),
                      currency: c.price.currency,
                    },
                    price_wd: {
                      amount: c.price_wd.amount * (result.marginOnProduct || 1),
                      currency: c.price.currency,
                    },
                    price_wd_vat: {
                      amount:
                        c.price_wd_vat.amount * (result.marginOnProduct || 1),
                      currency: c.price.currency,
                    },
                  }),
                ),
            }),
          );

          const selectedComplementar =
            editedVariants &&
            editedVariants[0] &&
            editedVariants[0].complementary_products[0] &&
            editedVariants[0].complementary_products[0];

          this.setState({
            prices: result.prices || [],
            shadeProperties: result.shade_properties || [],
            colorants: result.coloraunts || [],
            shadeOfBase: result.shade_of_base || '',
            colorcardName: colorCardDetail.name,
            color: colorCardDetail.shades.find(s => s.color_code === colorId),
            selectedColorId: colorId,
            variants: editedVariants,
            selectedVariant: editedVariants[0],
            selectedComplementar,
            complementarQuantity: selectedComplementar
              ? (selectedComplementar.count || 1) * this.state.quantity
              : 0,
            shade,
            selectedColorCardPurpose: completeColorCard.purpose,
            selectedColorCardId: completeColorCard._id,
            selectedToningSystem: completeColorCard.system_id,
            pricesLoading: false,
          });
        }
      } else if (outputCallback) {
        outputCallback({
          prices: variants
            .filter(v => v.finished_shade === colorId)
            .map(v => ({
              name: v.name,
              _id: v._id,
              default_price: v.price,
              finished_effect: v.finished_effect,
              volume: v.volume,
            })),
          shadeProperties: [],
          colorants: [],
          bases: [],
          shadeOfBase: '',
          color: colorCardDetail.shades.find(s => s.color_code === colorId),
          availableBases: [],
          selectedColorId: colorId,
          selectedColorCardId: completeColorCard._id,
          selectedToningSystem: completeColorCard.system_id,
          finished_shade: true,
        });

        this.setState({
          error: false,
          prices: [],
          variants: [],
          shadeProperties: [],
          shade: undefined,
          selectedColorCardPurpose: undefined,
          selectedColorId: undefined,
          selectedColorCardId: undefined,
          selectedToningSystem: undefined,
          productId: undefined,
          pricesLoading: false,
        });
      } else {
        const variantsWithColorId = variants
          .filter(v => v.finished_shade === colorId)
          .map(v =>
            Object.assign(v, {
              name: v.name,
              _id: v._id,
              default_price: v.price,
              finished_effect: v.finished_effect,
              volume: v.volume,
            }),
          );

        this.setState({
          selectedColorId: colorId,
          colorants: [],
          shadeProperties: [],
          variants,
          selectedVariant: variantsWithColorId[0],
          shade,
          pricesLoading: false,
          color: colorCardDetail.shades.find(s => s.color_code === colorId),
          prices: variantsWithColorId,
        });
      }
    } catch (e) {
      console.log(e);
      if (e.details.name === 'FORMULA_NOT_FOUND') {
        this.setState({
          error: __('Nenašla sa receptúra pre daný odtieň'),
          pricesLoading: false,
        });
      } else {
        this.setState({
          error: __('Farbu sa nepodarilo natónovať'),
          pricesLoading: false,
        });
      }

      return;
    }

    this.setState({
      shade,
    });
  }

  handleComplementarChange(variantId, complementarId) {
    const { variants } = this.state;

    this.setState({
      complementarQuantity: 0,
      selectedComplementar: variants
        .find(v => v._id === variantId)
        .complementary_products.find(c => c._id === complementarId),
    });
  }

  handleVariantChange(variantId) {
    const { variants } = this.state;

    const selectedVariant = variants.find(v => v._id === variantId);

    const selectedComplementar =
      selectedVariant &&
      selectedVariant.complementary_products[0] &&
      selectedVariant.complementary_products[0];

    this.setState({
      selectedVariant,
      selectedComplementar,
      complementarQuantity: selectedComplementar
        ? (selectedComplementar.count || 1) * this.state.quantity
        : 0,
      quantity: 1,
    });
  }

  handleQuantityChange(quantity) {
    const { selectedComplementar } = this.state;
    let { complementarQuantity } = this.state;

    if (selectedComplementar) {
      complementarQuantity = (selectedComplementar.count || 1) * quantity;
    }

    this.setState({
      quantity,
      complementarQuantity,
    });
  }

  handleComplementarQuantityChange(quantity) {
    this.setState({
      complementarQuantity: quantity,
    });
  }

  async processThirdStep(variantId, volume) {
    const { variants, quantity } = this.state;
    this.setState({
      selectedVariant: variants.find(v => v._id === variantId),
      quantity: volume > 0 ? volume : quantity,
    });
  }

  render() {
    const {
      error,
      bases,
      prices,
      availableBases,
      color,
      shadeProperties,
      colorants,
      shadeOfBase,
      productId,
      selectedVariant,
      selectedComplementar,
      shade,
      selectedColorId,
      variants,
      quantity,
      complementarQuantity,
      pricesLoading,
      variantBases,
      colorcardId,
      colorId,
      shadeBases,
      brandsFilter,
      colorcardName,
    } = this.state;

    const { confirmButtonTitle, includeSteps } = this.props;

    return (
      <React.Fragment>
        <ErrorWrapper>
          <ErrorMessage display={error} text={error} />
        </ErrorWrapper>

        <Wrapper rowDisabled={includeSteps.length === 2}>
          {productId && (
            <ButtonWrapper>
              <Button small danger onClick={() => this.reset()}>
                {__('Zrušiť')}
              </Button>
            </ButtonWrapper>
          )}
          <InsideWrapper>
            {includeSteps.indexOf(1) > -1 && (
              <AnimatedFormMessageWrapper width="100%" display>
                <ToningCardFilter
                  firm={this.props.firm}
                  onFilterChange={value => {
                    this.setState({
                      brandsFilter: value,
                    });
                  }}
                />
                <Space />
                <ToningCard title={__('Produkt')} icon="painting_roller">
                  <FirstStep
                    firm={this.props.firm}
                    productId={productId}
                    callback={(productIdOut, _bases, refreshNextSteps) =>
                      this.processFirstStep(
                        productIdOut,
                        _bases,
                        refreshNextSteps,
                      )
                    }
                    brandsFilter={brandsFilter}
                  />
                </ToningCard>
              </AnimatedFormMessageWrapper>
            )}
            <Space />
            {includeSteps.indexOf(2) > -1 && (
              <AnimatedFormMessageWrapper display={productId}>
                <ToningCard title={__('Odtieň')} icon="color_lens">
                  <SecondStep
                    callback={(_colorcardId, s) =>
                      this.processSecondStep(_colorcardId, s)
                    }
                    resetNextSteps={() => {
                      this.updateQueryMultiple(['colorId', 'colorcardId']);
                      this.setState({
                        shade: null,
                        selectedVariant: null,
                        selectedComplementar: null,
                        quantity: 1,
                        complementarQuantity: 0,
                        selectedColorId: null,
                      });
                    }}
                    bases={variantBases}
                    loading={pricesLoading}
                    productId={productId}
                    colorcardId={colorcardId}
                    colorId={colorId}
                    shadeBases={shadeBases}
                    firm={this.props.firm}
                  />
                </ToningCard>
              </AnimatedFormMessageWrapper>
            )}
          </InsideWrapper>
          <InsideWrapper>
            {includeSteps.indexOf(3) > -1 && (
              <AnimatedFormMessageWrapper display={shade}>
                <ToningCard title={__('Množstvo')} icon="view_module">
                  <ThirdStep
                    variants={variants}
                    quantity={quantity}
                    complementarQuantity={complementarQuantity}
                    selectedVariant={selectedVariant}
                    selectedComplementar={selectedComplementar}
                    handleVariantQuantityChange={(variantId, q) =>
                      this.processThirdStep(variantId, q)
                    }
                    handleComplementarChange={(variantId, complementarId) =>
                      this.handleComplementarChange(variantId, complementarId)
                    }
                    handleVariantChange={variantId =>
                      this.handleVariantChange(variantId)
                    }
                    handleQuantityChange={q => this.handleQuantityChange(q)}
                    handleComplementarQuantityChange={q =>
                      this.handleComplementarQuantityChange(q)
                    }
                  />
                </ToningCard>
              </AnimatedFormMessageWrapper>
            )}
            <Space />
            {includeSteps.indexOf(4) > -1 && (
              <AnimatedFormMessageWrapper display={selectedColorId}>
                <ToningCard title={__('Sumár')} icon="assignment">
                  <FourthStep
                    prices={prices}
                    quantity={quantity}
                    bases={bases}
                    colorcardName={colorcardName}
                    complementarQuantity={complementarQuantity}
                    product={selectedVariant}
                    complementarProduct={selectedComplementar}
                    shadeOfBase={shadeOfBase}
                    shadeProperties={shadeProperties}
                    colorants={colorants}
                    availableBases={availableBases}
                    color={color}
                    confirmButtonTitle={confirmButtonTitle}
                    onConfirm={o => this.onConfirm(o)}
                    showButton={this.props.showButton}
                    loading={this.props.addLoading}
                    compMargin={this.state.compMargin}
                  />
                </ToningCard>
              </AnimatedFormMessageWrapper>
            )}
          </InsideWrapper>
        </Wrapper>
      </React.Fragment>
    );
  }
}
Toning.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  firm: PropTypes.string.isRequired,
  confirmButtonTitle: PropTypes.string,
  onConfirm: PropTypes.func,
  clearAfterConfirm: PropTypes.bool,
  includeSteps: PropTypes.arrayOf(PropTypes.number),
  inputProduct: PropTypes.shape({
    variants: PropTypes.arrayOf({}),
    _id: PropTypes.string,
  }),
  customerId: PropTypes.string,
  reload: PropTypes.bool,
  outputCallback: PropTypes.func,
  showButton: PropTypes.bool,
  addLoading: PropTypes.bool,
  applyMargin: PropTypes.bool,
  applyDiscount: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    show_purchase_prices_CZ: PropTypes.bool,
    show_purchase_prices: PropTypes.bool,
  }).isRequired,
};

Toning.defaultProps = {
  confirmButtonTitle: 'Exportovať',
  onConfirm: () => {},
  clearAfterConfirm: false,
  outputCallback: null,
  includeSteps: [1, 2, 3, 4],
  inputProduct: null,
  customerId: undefined,
  reload: false,
  showButton: false,
  addLoading: false,
  applyMargin: false,
  applyDiscount: false,
};

const mapStateToProps = state => {
  return { ...state };
};

export default connect(state => mapStateToProps(state))(Toning);



// WEBPACK FOOTER //
// ./src/Containers/Toning/index.jsx